/* istanbul ignore file */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { configStore } from '@vfde-fe/sails_core';
import GlasfaserVfp from './container/GlasfaserVfp';

const store = configStore({});
store && GlasfaserVfp();
